import { PHYS_SCALE, b2Body, b2BodyDef, b2CircleShape, b2FixtureDef } from "./box2d-compat.js";

function snapToFlashTwips(value) {
  return Math.trunc(value * 20) / 20;
}

export class PlayerBox {
  constructor(world, x, y) {
    this.radius = 10.5;
    this.controlPointCount = 16;
    this.testPoints = [];
    const bodyDef = new b2BodyDef();
    bodyDef.position.Set(x / PHYS_SCALE, y / PHYS_SCALE);
    bodyDef.userData = this;

    const fixtureDef = new b2FixtureDef();
    fixtureDef.density = 1;
    fixtureDef.friction = 0.4;
    fixtureDef.restitution = 0.2;
    fixtureDef.shape = new b2CircleShape(this.radius / PHYS_SCALE);

    this.body = world.CreateBody(bodyDef);
    this.body.SetBullet(true);
    this.body.CreateFixture(fixtureDef);
    this.body.SetMassFromShapes();
    this.alive = true;

    const angleStep = (2 * Math.PI) / this.controlPointCount;
    for (let index = 0; index < this.controlPointCount; index += 1) {
      this.testPoints.push({
        x: this.radius * Math.cos(angleStep * index),
        y: this.radius * Math.sin(angleStep * index),
      });
    }
  }

  get x() {
    return snapToFlashTwips(this.body.GetPosition().x * PHYS_SCALE);
  }

  get y() {
    return snapToFlashTwips(this.body.GetPosition().y * PHYS_SCALE);
  }

  isLive() {
    return this.alive;
  }

  hitTestObjectControlPoints(target) {
    if (!target || !this.alive) {
      return false;
    }
    const angle = this.body.GetAngle();
    const cos = Math.cos(angle);
    const sin = Math.sin(angle);
    for (const point of this.testPoints) {
      const worldX = this.x + point.x * cos - point.y * sin;
      const worldY = this.y + point.x * sin + point.y * cos;
      if (worldX >= target.x && worldX <= target.x + target.width && worldY >= target.y && worldY <= target.y + target.height) {
        return true;
      }
    }
    return false;
  }

  kill(world) {
    if (!this.alive) {
      return;
    }
    world.DestroyBody(this.body);
    this.alive = false;
  }
}
